import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

interface Props {
  background: string;
}

const useStyles = makeStyles<Theme, Props>((theme) =>
  createStyles({
    wrapper: {
      width: '100%',
      position: 'absolute',
      top: '50%',
      zIndex: 0,
    },

    container: {
      minHeight: 85,
      padding: theme.spacing(1, 3, 3),
      background: ({ background }) => background,
      borderRadius: '20px 20px 0px 0px',
      alignItems: 'center',
    },

    textContainer: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'space-evenly',

      '& h1': {
        color: theme.palette.primary.contrastText,
        fontSize: theme.typography.pxToRem(22),
        fontWeight: theme.typography.fontWeightBold,
      },
    },

    iconContainer: {
      alignItems: 'center',
      justifyContent: 'flex-end',

      '& img': {
        width: '100%',
        height: '100%',
        maxWidth: 35,
        maxHeight: 55,
      },
    },

    button: {
      maxWidth: 100,
      color: theme.palette.primary.contrastText,
      textTransform: 'initial',
    },
  })
);

export default useStyles;
